import { memo } from 'react';

const AdminModal = ({
    isOpen,
    onClose,
    adminPrices,
    addNewRow,
    handleFieldChange,
    markForDeletion,
    saveAdminPrices,
    fetchAdminPrices,
    fetchPrices,
    isSaving,
    lastSaved,
    changedRows
}) => {
    if (!isOpen) return null;

    return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 3000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px' }} onClick={onClose}>
            <div style={{ background: 'white', width: '100%', maxWidth: '1000px', maxHeight: '90vh', borderRadius: '16px', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 20px 50px rgba(0,0,0,0.5)' }} onClick={(e) => e.stopPropagation()}>
                <div style={{ padding: '25px', background: 'rgb(255, 215, 0)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                        <h2 style={{ margin: 0, fontWeight: 900, color: 'rgb(0, 40, 70)' }}>PRICING DATABASE</h2>
                        <button onClick={addNewRow} style={{ background: 'rgb(0, 40, 70)', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '6px', cursor: 'pointer', fontWeight: 700, fontSize: '12px' }}>+ ADD NEW ROW</button>
                    </div>
                    <div onClick={onClose} style={{ cursor: 'pointer', fontSize: '24px', fontWeight: 900 }}>&times;</div>
                </div>

                {/* Table Area */}
                <div className="custom-scrollbar" style={{ flex: 1, overflowY: 'auto', padding: '25px' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                        <thead>
                            <tr style={{ textAlign: 'left', borderBottom: '2px solid rgb(0, 40, 70)' }}>
                                <th style={{ padding: '12px', width: '120px' }}>CODE</th>
                                <th style={{ padding: '12px' }}>DESCRIPTION</th>
                                <th style={{ padding: '12px', width: '120px' }}>PRICE (€)</th>
                                <th style={{ padding: '12px', width: '80px', textAlign: 'center' }}>ACTION</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Check if data exists before mapping */}
                            {adminPrices && adminPrices.length > 0 ? (
                                adminPrices.map((item, idx) => (
                                    <tr key={idx} style={{
                                        borderBottom: '1px solid #eee',
                                        background: changedRows.has(item.Code) ? '#fffbeb' : 'transparent'
                                    }}>
                                        <td style={{ padding: '12px' }}>
                                            <input
                                                type="text"
                                                value={item.Code}
                                                onChange={(e) => handleFieldChange(idx, 'Code', e.target.value)}
                                                style={{ padding: '8px', width: '100%', border: '1px solid #ddd', borderRadius: '4px', fontWeight: 700 }}
                                            />
                                        </td>
                                        <td style={{ padding: '12px' }}>
                                            <input
                                                type="text"
                                                value={item.Description || "New Item"}
                                                onChange={(e) => handleFieldChange(idx, 'Description', e.target.value)}
                                                style={{ padding: '8px', width: '100%', border: '1px solid #ddd', borderRadius: '4px' }}
                                            />
                                        </td>
                                        <td style={{ padding: '12px' }}>
                                            <input
                                                type="number"
                                                min="0"
                                                step="1"
                                                value={item.Price}
                                                onChange={(e) => handleFieldChange(idx, 'Price', e.target.value)}
                                                style={{ padding: '8px', width: '100%', border: '1px solid #ddd', borderRadius: '4px', fontWeight: 700 }}
                                            />
                                        </td>
                                        <td style={{ padding: '12px', textAlign: 'center' }}>
                                            <button
                                                onClick={() => markForDeletion(idx, item.Code)}
                                                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', fontSize: '18px', padding: '5px' }}
                                            >
                                                🗑️
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                // Fallback for hacked/unauthenticated access
                                <tr>
                                    <td colSpan="4" style={{ textAlign: 'center', padding: '60px', color: '#64748b', fontWeight: 700 }}>
                                        {isSaving ? "SYNCING..." : "NO DATA AVAILABLE"}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Footer Buttons */}
                <div style={{ padding: '20px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '20px' }}>
                    {lastSaved && (
                        <div style={{ color: '#059669', fontSize: '13px', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span style={{ fontSize: '16px' }}>✓</span> Saved at {lastSaved}
                        </div>
                    )}
                    <button
                        onClick={onClose}
                        disabled={isSaving}
                        style={{ padding: '12px 25px', borderRadius: '8px', border: '1px solid #ddd', background: 'white', cursor: isSaving ? 'not-allowed' : 'pointer', fontWeight: 700 }}
                    >
                        CLOSE
                    </button>
                    <button
                        onClick={async () => {
                            await saveAdminPrices(); // Runs DB updates
                            setTimeout(() => {
                                fetchAdminPrices();
                                fetchPrices();      // Refresh sidebar totals
                            }, 500);
                        }}
                        disabled={isSaving || !adminPrices.length}
                        style={{
                            padding: '12px 25px',
                            borderRadius: '8px',
                            border: 'none',
                            background: 'rgb(0, 40, 70)',
                            color: 'white',
                            cursor: (isSaving || !adminPrices.length) ? 'not-allowed' : 'pointer',
                            fontWeight: 700,
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        }}
                    >
                        {isSaving ? "SAVING..." : "SAVE CHANGES"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default memo(AdminModal);